<template>
    <router-link class="cursor-pointer group block" :to="link">
        <div class="group rounded-md relative overflow-hidden" @click="this.$emit('update:active', index)">
            <div class="flex flex-row gap-4 h-full">
                <div class="w-1/2 flex items-center justify-start">
                    <img alt="Video" :src="data?.meta?.snippet?.thumbnails?.high?.url" ref="image" class="w-full rounded-md" />
                </div>

                <div class="w-1/2 flex flex-col justify-between">
                    <h2 class="base_bold mt-2">
                        {{ data.meta.snippet.title }}
                    </h2>
                    <div>{{ formatDateByRegion($moment(data.meta.snippet.publishedAt)) }}</div>
                    <div class="flex flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center mt-2">
                        {{ $t('plain_view') }}
                        <Icon type="ArrowRight" viewBox="0 0 29 21" width="18" height="10" class="fill-none stroke-current" />
                    </div>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
import { formatDateByRegion } from '../../helpers.js';

export default {
    methods: { formatDateByRegion },
    props: ['active', 'data', 'index'],
    emits: ['update:active'],

    computed: {
        link() {
            return '/videos/' + this.data.slug.name;
        }
    }
};
</script>
